import React, { PureComponent } from "react";

export default class TO extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#d80027"
          />
          <rect
            width="256"
            height="170.663"
            transform="translate(0 85.331)"
            fill="#f0f0f0"
          />
          <path
            d="M141.357,157.3V130.59H114.643V157.3H87.93v26.713h26.713v26.713h26.714V184.016H168.07V157.3Z"
            fill="#d80027"
          />
        </g>
      </svg>
    );
  }
}
